import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuardAllowService {
  
  private allowedToAccess: boolean = false;

  constructor(private cookieService: CookieService, private router: Router) {}

  canActivate(): boolean {
    const tokenExists = this.cookieService.check('sessionToken');

    if (!tokenExists && this.allowedToAccess) {
      return true;
    }
    if(!tokenExists && !this.allowedToAccess){
      //this.router.navigate(['/login']);
      //return false;
      return true;
    }
    if(tokenExists && !this.allowedToAccess){
      this.router.navigate(['/usuarios']);
      return false;
    }
    if(tokenExists && this.allowedToAccess){
      this.router.navigate(['/usuarios']);
      return false;
    }
    return false;
  }

  allowAccess() {
    this.allowedToAccess = true;
  }
}
